import React, { Component } from "react";
import Podcastfront from "./podcastfront";
import Wpfront from "./wpfront";
import { Router, Link } from "@reach/router";
import Homecard from "./homecard";
import Aboutcard from "./aboutcard";

class Mainfront extends Component {
  state = {
    latestposttitle: "searching...",
    firstpostcontent: "looking up..."
  };
  constructor(props) {
    super(props);

    this.x = `<header id='topheader'>
    <nav id='topnav'>
        <ul id='navlist'>
            <li><a href='http://eepurl.com/8auar'>Email List</a></li>
            <li><a href='https://twitter.com/pacificpelican'>Twitter</a></li>
            <li><a href="https://github.com/pacificpelican">GitHub</a></li>
        </ul>
      </nav>
  </header>`;
  }

  componentDidMount() {}

  render() {
    return (
      <div className="hero-image">
        <p className="hero-text" id="wallpaper">
          <h1 className="App-title">
            <a href="../../..">DJMCLOUD</a>
          </h1>
          <span>
            from <a href="http://danmckeown.info">Dan McKeown</a>
          </span>
        </p>
        <section id="team" className="hero-desc">
          <h5>Links</h5>
          <ul id="members">
            <li>
              <nav>
                <Link to="/about">About</Link>
              </nav>
            </li>
            <li>
              <nav>
                <Link to="latest">Latest Episode</Link>
              </nav>
            </li>
            <li>
              <nav>
                <Link to="podcast">Subscribe</Link>
              </nav>
            </li>
            <li>
              <a href="http://danmckeown.info/djmcloud">
                Sticker Pack for iMessage
              </a>
            </li>
          </ul>
        </section>
        <div id="routerDiv">
          <Router>
            <Homecard path="/" />
            <Aboutcard path="/about" />
            <Wpfront path="latest" />
            <Podcastfront path="podcast" />
          </Router>
        </div>
        <footer id="linkFooter">
          <ul id="members">
            <li>
              <a href="http://lovebirdsconsulting.com">Love Birds Consulting</a>
              : web development services
            </li>
          </ul>
        </footer>
        <br />
        <br />
      </div>
    );
  }
}

export default Mainfront;



// WEBPACK FOOTER //
// ./src/mainfront.js